<!--suppress JSUnusedGlobalSymbols -->
<template>
    <section class="readmore">
        <swiper :options="swiperOptions">
            <swiper-slide v-for="article in articles" :key="article.title">
                <a :href="article.url" class="readmore-element" @click.prevent.stop="openArticle(article.slug)">
                    <img class="readmore-element-img"
                         :src="article.media[thumbnail_size].url"
                         :alt="article.media[thumbnail_size].alt">
                    <div class="readmore-element-title" v-html="article.title"></div>
                    <div class="readmore-element-date">{{ article.formatted_date }}</div>
                    <div class="readmore-element-tag">
                        <tags :categories="article.categories" size="small"></tags>
                    </div>
                </a>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev">
                <svg version="1.1" id="Chevron_thin_left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                     y="0px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
                <path fill="#FFFFFF" d="M13.891,17.418c0.268,0.272,0.268,0.709,0,0.979s-0.701,0.271-0.969,0l-7.83-7.908
                    c-0.268-0.27-0.268-0.707,0-0.979l7.83-7.908c0.268-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.979L6.75,10L13.891,17.418
                    z"/>
                </svg>
            </div>
            <div class="swiper-button-next" slot="button-next">
                <svg version="1.1" id="Chevron_thin_right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                     y="0px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
                <path fill="#FFFFFF" d="M13.25,10L6.109,2.58c-0.268-0.27-0.268-0.707,0-0.979c0.268-0.27,0.701-0.27,0.969,0l7.83,7.908
                    c0.268,0.271,0.268,0.709,0,0.979l-7.83,7.908c-0.268,0.271-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.979L13.25,10z"/>
                </svg>
            </div>
        </swiper>
    </section>
</template>

<script>
	import {swiper, swiperSlide} from 'vue-awesome-swiper';
	import router from "./router";
	import Tags from "./tags.vue";
	import axios from "axios";
	import {truncate} from "../shared/helper";

	export default {
		components: {
			swiper,
			swiperSlide,
            Tags
		},
        props: {
		    news: {
		    	default: true
            },
			features: {
				default: true
			},
            rows: {
		    	default: 1
            },
            thumbnail_size: {
		    	default: "chillnews_mikado_landscape"
            },
            currentArticle: {
		    	default: 0
            },
            columns: {
		    	default: 3
            },
            amount: {
		    	default: 12
            }
        },
		mounted () {
			this.fetchData();
        },
        updated () {
			this.fetchData();
        },
        computed: {
		    cacheContainer () {
		    	return  window.__REAMORE_CACHE__ ===  Object(window.__REAMORE_CACHE__) ? window.__REAMORE_CACHE__ : ( window.__REAMORE_CACHE__ = {} )
            }
        },
		methods: {
			openArticle (slug) {
				router.push({path: `/article/${slug}`})
			},
            fetchData () {
				let {thumbnail_size,news,features,currentArticle, amount} = this;
				let settings = JSON.stringify({
					thumbnail_size,
                    news,
                    features,
                    currentArticle
                });
				if (this.cacheContainer[settings]) {
					this.articles = this.cacheContainer[settings];
				} else {
					axios.get('/wp-json/news/v2/readmore', {
						params: {
							amount,
							news,
							features,
							thumbnail_size,
							currentArticle
						}
					}).then((response) => {
						this.cacheContainer[settings] = this.articles = response.data;
					});
				}
            },
			truncate,
		},
		data () {
			return {
				articles: [],
				swiperOptions: {
					breakpoints: {
						1024: {
							slidesPerView: 3
						},
						640: {
							slidesPerView: 2
						},
						480: {
							slidesPerView: 1,
							slidesPerColumn: 1
						}
					},
					slidesPerView: this.columns,
					slidesPerColumn: this.rows,
					paginationClickable: true,
					pagination: '.swiper-pagination',
					prevButton: '.swiper-button-prev',
					nextButton: '.swiper-button-next',
				}
			};
		}
	}
</script>

<style lang="scss" scoped>
    @import "../news/slide";
    div.swiper-container {
        box-shadow: none;
    }
    .readmore-element-tag {
        margin: 5px 0;
    }
    .readmore {
        width: 100%;
        margin-bottom: 1rem;
    }

    .readmore h3 {
        margin-left: 1rem;
        margin-top: 0;
    }

    .readmore-element {
        display: block;
        margin: 1rem;
        transition: 100ms all;
        opacity: .8;
    }

    .readmore-element:hover {
        border-left: .5rem solid #577f40;
        background: #f1f1f1;
        padding-left: .5rem;
        opacity: 1;
        .readmore-element-title {
            font-size: 1.05rem;
        }
    }

    .readmore-element-title {
        font-size: 1.1rem;
        color: #2f2f2f;
    }

    .readmore-element-date {
        color: grey;
    }

    .readmore-element-img {
        display: block;
        width: 100%;
        margin-bottom: .5rem;
    }
</style>


// WEBPACK FOOTER //
// readmore.vue?caac0580